import * as React from "react";

export type ScoreboardProps = {
    team1: Array<string>
    team2: Array<string>
    endingPoint1?: string
    endingPoint2?: string
    classNames?: string
}

export class Scoreboard extends React.PureComponent<ScoreboardProps, {}>
{
    render() {
        const { team1, team2, endingPoint1, endingPoint2, classNames } = this.props;
        return (
            <div className={"rj-ev-list__scoreboard" + (classNames ? ` rj-ev-list__scoreboard--${classNames}` : "")} data-uat="div-ev-list-scoreboard">
                <div className={"rj-ev-list__scoreboard__player"} data-uat="div-ev-list-scoreboard-player">
                    {
                        team1.map((item, index) => (
                            <div key={index} className={"rj-ev-list__scoreboard__info"} data-uat="div-ev-list-scoreboard-info">{item}</div>
                        ))
                    }
                    {endingPoint1 && <div className={"rj-ev-list__scoreboard__info-total"} data-uat="div-ev-list-scoreboard-info-total">{endingPoint1}</div>}
                </div>
                <div className={"rj-ev-list__scoreboard__player"} data-uat="div-ev-list-scoreboard-player">
                    {
                        team2.map((item, index) => (
                            <div key={index} className={"rj-ev-list__scoreboard__info"} data-uat="div-ev-list-scoreboard-info">{item}</div>
                        ))
                    }
                    {endingPoint2 && <div className={"rj-ev-list__scoreboard__info-total"} data-uat="div-ev-list-scoreboard-info-total">{endingPoint2}</div>}
                </div>
            </div>
        )
    }
}